import React from "react";
import { Button } from "@material-ui/core";
import { GetApp } from "@material-ui/icons";
import { useTranslation } from "react-i18next";

const ExportPdfButton = ({ onClick, loading = false, className = "" }) => {
	const { t } = useTranslation();

	return (
		<Button
			variant="outlined"
			size="small"
			startIcon={<GetApp />}
			onClick={onClick}
			disabled={loading}
			className={`export-pdf-button ${className}`}
			style={{
				textTransform: "none",
				borderColor: "#393762",
				color: "#393762",
				fontSize: "0.875rem",
				padding: "4px 12px",
				minWidth: "100%",
				whiteSpace: "nowrap",
			}}>
			{loading ? t("reports.buttons.exporting") : t("reports.buttons.exportPdf")}
		</Button>
	);
};

export default ExportPdfButton;